module.exports = __webpack_public_path__ + "img/dog5.c9dbcaef.jpg";